import useUserStore from "../Store/useUserStore";
import useBoxOrderStore from "../Store/useBoxOrderStore";
import usePaymentStore from "../Store/usePaymentStore";
import { signOut } from "next-auth/react";
import { STYLE_MY_WARDROBE } from "../../public/Constants/EnumConstants";
import { deleteCookie } from "cookies-next";

export const useResetAllStores = () => {
    const { userData, resetBoxItems, resetUser } = useUserStore();
    const { resetBox } = useBoxOrderStore();
    const { resetPayment } = usePaymentStore();

    const resetAllStores = ({ logout = false } = {}) => {
        localStorage?.removeItem("surveyAnswers");
        localStorage?.removeItem("surveyQuestions");
        localStorage?.removeItem("StyleMyWardrobeAnswers");
        localStorage?.removeItem("apple-name-modal");

        deleteCookie(STYLE_MY_WARDROBE);

        if (logout) {
            signOut({ redirect: false }).then(() => {
                if (userData) {
                    resetBoxItems?.();
                    resetUser?.();
                    resetBox?.();
                    resetPayment?.();
                }
                // window.location.href = "/login";
            });
        }
    };

    return resetAllStores;
};
